import { HttpClient } from 'api/helpers/HttpClient';

export const getPlayerMediaService = async ({
  url,
  formData,
  params,
  claroLiteConfig,
}) => {
  const apiCall = new HttpClient({ hasClaroAdActive: claroLiteConfig });
  return await apiCall.post(url, formData, params);
};
